import './antd.less';
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    @keyframes loading {
            100% {
            transform: translateX(100%);
            }
    }
    .gantt_task_line{
        background:unset;
        border:unset
    }
    .skeleton {
        position: relative;
        background-color: #b2b2b2;
        max-width: 100%;
        overflow: hidden;
        &::after {
        top:0px;
        left:0px;
        display: block;
        content: '';
        position: absolute;
        max-width: 100%;
        overflow: hidden;
        width: 100%;
        height: 100%;
        transform: translateX(-100%);
        background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.1),
            transparent
        );
        animation: loading 1.5s infinite;
        }
    }
    // with 
    ${[50, 100].map((size) => `.w-${size} {width: ${size}%;}`)}

    
    
    .position-absolute{
      position:absolute!important;
    }
    .box-shadow{
        box-shadow: var(--box-shadow);
    }
    .border-solid{
       border: solid 1px;
    }
    .cursor-pointer{
      cursor: pointer;
    }
    .d-flex{
      display: flex!important;
    }
    .d-inline-flex{
      display: inline-flex!important;
    }
    .d-none{
      display: none!important;
    }
    .border-none{
      border: none!important;
    }
    .d-block{
      display: block!important;
    }
    .justify-end{
      justify-content: end!important;
    }
    .justify-center{
      justify-content: center!important;
    }
    .align-center{
      align-items: center;
    }
    .justify-between{
      justify-content: space-between;
    }
    .flex-column{
      flex-direction: column;
    }
    .text-center{
      text-align: center;
    }
    ${[3, 4, 6].map((fw) => `.fw-${fw} {font-weight: ${fw}00;}`)}
    ${[4, 9].map((bdr) => `.br-${bdr} { border-radius:${bdr}px;}`)}
    ${[10, 12, 14, 16].map((fz) => `.fs-${fz} {font-size: ${fz}px;}`)}
    [role~='button'] {
      cursor: pointer;
    }

    ${[0, 4, 7, 8, 16, 32].map((size) => `.height-${size} {height: ${size}px;}`)}

    ${[0, 4, 7, 8, 16, 32].map((size) => `.m-${size} {margin: ${size}px;}`)}
    ${[0, 4, 7, 8, 16, 32].map((size) => `.mr-${size} {margin-right: ${size}px;}`)}
    ${[0, 4, 7, 8, 16, 32].map((size) => `.ml-${size} {margin-left: ${size}px;}`)}
    ${[0, 4, 7, 8, 16, 32].map((size) => `.mt-${size} {margin-top: ${size}px;}`)}
    ${[0, 4, 7, 8, 16, 32].map((size) => `.mb-${size} {margin-bottom: ${size}px;}`)}
    ${[0, 4, 7, 8, 16, 32].map((size) => `.p-${size} {padding: ${size}px;}`)}
    ${[0, 4, 7, 8, 16, 32].map((size) => `.pr-${size} {padding-right: ${size}px;}`)}
    ${[0, 4, 7, 8, 16, 32].map((size) => `.pl-${size} {padding-left: ${size}px;}`)}
    ${[0, 4, 7, 8, 16, 32].map((size) => `.pt-${size} {padding-top: ${size}px;}`)}
    ${[0, 4, 7, 8, 16, 32].map((size) => `.pb-${size} {padding-bottom: ${size}px;}`)}
    
    // custom
    .ant-checkbox-wrapper span:last-child {
      font-size: 16px;
    }
    .ant-select-item-option-content {
        white-space: break-spaces;
        flex: auto;
        overflow: auto;
        text-overflow: initial;
        max-width: 100%;
        word-break: break-all;
    }
    .ant-select-item-option{
      font-size: 12px;
      letter-spacing: 0.39px;
      line-height: 20px;
      min-height: 24px;
      padding: 0px 12px;
      .content-option{
          width:100%;
        display: flex;
        justify-content: center;
        align-items: center;
          flex-wrap: wrap;
      }
     

    }
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color:unset;
      .content-option{
        height: 24px;
        color: #FFFFFF;
        border-radius: 4px;
        background-color: #2666BF;
       
      }
   
  }
`;
